module.exports = __webpack_public_path__ + "img/logo-app-2.old.77dfb871.png";